import { api, LightningElement } from "lwc";

export default class extends LightningElement {
  @api avatarUrl: string = undefined!;
  @api fullName: string = undefined!;
}
